export default __webpack_public_path__ + "static/media/shopWomens.872b5c9e.jpg";